import { ReviewHeader } from "./components/ReviewHeader";
import { ReviewContent } from "./components/ReviewContent";
import { JSX } from "react";

export const ReviewPageContainer = (): JSX.Element => {
    return (
        <div className="p-review">
            <ReviewHeader />
            <ReviewContent />
        </div>
    );
};
